import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Accordion, Card } from 'react-bootstrap'
import classNames from 'classnames'

import CampaignHeader from 'components/Recommendations/Campaign/CampaignHeader'
import Menu from 'components/Shared/Menu'
import { CampaignEditor } from 'components/Recommendations/Campaign/Edit'
import { isCampaignOpen, isCampaignRunning, tcDisplayName } from 'api/models'
import RunningCampaign from 'components/Recommendations/Campaign/RunningCampaign'
import { useToast } from 'components/Shared/AppToast/ToastProvider'

import moreDots from '../../../../../../images/icons/more_horiz.svg'
import share from '../../../../../../images/icons/share.svg'
import edit from '../../../../../../images/icons/edit.svg'

function getCampaignTcLabelStatus(campaign) {
    if (isCampaignRunning(campaign))
        return null
}

const RunningCampaigns = ({ event, campaigns = [], setSharedTc, editedTc, setEditedTc, initialGoal, refetchCampaigns, isFutureEvent }) => {
    const { t } = useTranslation()
    const { addNotification } = useToast()

    const [activeKey, setActiveKey] = useState(null)
    const [activeTcMenu, setActiveTcMenu] = useState(null)

    return campaigns.map((campaign, index) => {
        return <Accordion key={`${campaign.tc}/${campaign.tc_run_id}`} activeKey={activeKey?.toString()} className='p-0'>
            <Card className={classNames({
                campaign: true,
                active: activeKey && Number(activeKey) === index,
                'campaign--bodiless': isCampaignOpen(campaign),
            })}>
                <Accordion.Toggle eventKey={index.toString()}>
                    <Card.Header
                        as={Card.Header}
                        className="pt-3"
                    >
                        <CampaignHeader
                            campaign={campaign}
                            headerStatus={getCampaignTcLabelStatus(campaign)}
                            onClick={() => {
                                if (isCampaignOpen(campaign)) return

                                setActiveKey(activeKey && index === Number(activeKey) ? null : index.toString())
                            }}
                            showActiveBadge={isFutureEvent}
                        >
                            <>
                                {isFutureEvent && <div
                                    className="recommendation__more-dots_wrapper"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <img
                                        style={{ width: 24 }}
                                        src={moreDots}
                                        alt='Campaign Options'
                                        onClick={() => setActiveTcMenu(campaign.tc)}
                                    />
                                </div>}
                                <div className="recommendation__chevron" onClick={() =>
                                    setActiveKey(activeKey && index === Number(activeKey) ? null : index.toString())
                                }></div>
                            </>
                            {isFutureEvent && <Menu
                                options={[
                                    {
                                        id: 'share',
                                        title: t('common.share'),
                                        optionType: 'button',
                                        clickHandler: () => setSharedTc(campaign.tc),
                                        icon: share,
                                    },
                                    {
                                        id: 'edit',
                                        title: t('common.edit'),
                                        disabled: editedTc === campaign.tc,
                                        hidden: !isCampaignRunning(campaign, { validateNotEnded: true }),
                                        optionType: 'button',
                                        clickHandler: (e) => {
                                            e.stopPropagation()
                                            if (!activeKey || index !== Number(activeKey))
                                                setActiveKey(index.toString())

                                            setEditedTc(campaign.tc)
                                        },
                                        icon: edit,
                                    },
                                ]}
                                toggleMenu={() => setActiveTcMenu(null)}
                                open={activeTcMenu === campaign.tc}
                            />}
                        </CampaignHeader>
                    </Card.Header>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={index.toString()}>
                    <Card.Body className='pt-0'>
                        <hr className="divider" />
                        {editedTc === campaign.tc
                            ?
                            <CampaignEditor
                                eventId={event.id}
                                eventDate={event.date}
                                campaign={campaign}
                                goal={initialGoal}
                                setup={{
                                    tc: campaign.tc,
                                    tc_run_id: campaign.tc_run_id,
                                    integration_details: campaign.latest_campaign_setup.integration_details,
                                    conversion_id: campaign.latest_campaign_setup.conversion_id,
                                    creatives: [{
                                        tc: campaign.tc,
                                        tc_run_id: campaign.tc_run_id,
                                        audience_id: campaign.latest_campaign_setup.audience_id,
                                        ...campaign.latest_campaign_setup.creative
                                    }]
                                }}
                                onChange={() => {}}
                                onCancel={() => {
                                    setEditedTc(null)
                                }}
                                onAfterSave={() => {
                                    addNotification({
                                        message: t('Toasts.Campaigns.campaignEdited.message'),
                                        description: t('Toasts.Campaigns.campaignEdited.description'),
                                    })
                                    setEditedTc(null)
                                    refetchCampaigns()
                                }}
                            />
                            :
                            <RunningCampaign
                                integrationDetails={campaign.latest_campaign_setup.integration_details}
                                tasteCluster={t('Recommendations.campaign.recommendationTitle', {
                                    tc: tcDisplayName(campaign),
                                })}
                                creative={campaign.latest_campaign_setup.creative}
                                audienceId={campaign.latest_campaign_setup.audience_id}
                            />
                        }
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    })
}

RunningCampaigns.propTypes = {
    event: PropTypes.object,
    campaigns: PropTypes.arrayOf(Object),
    setSharedTc: PropTypes.func,
    setEditedTc: PropTypes.func,
    editedTc: PropTypes.string,
    initialGoal: PropTypes.string,
    refetchCampaigns: PropTypes.func,
    isFutureEvent: PropTypes.bool
}

export default RunningCampaigns